// ============================================================================
// kozlemenyData.js — a KÖZLEMÉNY-postaláda dokumentumainak átalakítása és rendezése (2026-10-25).
// Külön, tiszta modul, hogy tesztelhető legyen (mint a noteData.js).
// ============================================================================

import { idopontMs } from "./noteData.js";

/** Egy postaláda-dokumentumból a kliens közlemény-objektuma (a küldő nevének írásmódjai ugyanazok, mint a cetlinél). */
export function kozlemenyDokumentumbol(docId, data) {
  const d = data || {};
  const szoveg = (v) => (typeof v === "string" ? v : "");
  return {
    annId: szoveg(d.annId) || docId,
    senderName: szoveg(d.senderName),
    senderNameLatn: szoveg(d.senderNameLatn),
    senderNameJa: szoveg(d.senderNameJa),
    senderNameZh: szoveg(d.senderNameZh),
    senderNameKo: szoveg(d.senderNameKo),
    senderNameCyr: szoveg(d.senderNameCyr),
    senderNameEl: szoveg(d.senderNameEl),
    text: szoveg(d.text),
    sourceLang: typeof d.sourceLang === "string" && d.sourceLang ? d.sourceLang : null,
    translatedText: szoveg(d.translatedText) || null,
    translatedLang: typeof d.translatedLang === "string" && d.translatedLang ? d.translatedLang : null,
    createdAt: idopontMs(d.createdAt),
    expireAt: idopontMs(d.expireAt),
  };
}

/** A megjelenítendők: a lejártak (a TTL-törlés késhet) kimaradnak; legrégebbi elöl (sorrendben olvasandók), legfeljebb `max`. */
export function megjelenitendoKozlemenyek(lista, now = Date.now(), max = 20) {
  return [...lista]
    .filter((k) => k && k.text && !(k.expireAt && k.expireAt < now))
    .sort((a, b) => a.createdAt - b.createdAt || (a.annId < b.annId ? -1 : 1))
    .slice(0, max);
}
